module.exports = __webpack_public_path__ + "static/media/loan_offer_blue.84935634.svg";